import React from 'react'
import { FormControl, FormLabel, RadioGroup, type SxProps, type Theme } from '@mui/material'

import { spacing } from '~tokens/internal'

import SelectionCard from './SelectionCard'

export interface RadioCardOption {
  value: string
  label: string
  description?: string
  icon?: React.ReactNode
  disabled?: boolean
  content?: React.ReactNode
}

export interface RadioCardGroupProps {
  label?: string
  options: RadioCardOption[]
  value?: string
  onChange?: (value: string) => void
  row?: boolean
  /** Layout for the icon within each card: 'side' (default) or 'top'. */
  iconLayout?: 'side' | 'top'
  controlPosition?: 'start' | 'end'
  sx?: SxProps<Theme>
}

const RadioCardGroup: React.FC<RadioCardGroupProps> = ({
  label,
  options,
  value,
  onChange,
  row = false,
  iconLayout = 'side',
  controlPosition = 'end',
  sx,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onChange?.(event.target.value)
  }

  return (
    <FormControl sx={{ width: '100%', ...sx }}>
      {label && <FormLabel sx={{ mb: spacing.xs }}>{label}</FormLabel>}
      <RadioGroup
        value={value}
        onChange={handleChange}
        sx={{
          display: 'flex',
          flexDirection: row ? 'row' : 'column',
          gap: spacing.xs,
        }}
      >
        {options.map((option) => (
          <SelectionCard
            key={option.value}
            controlType='radio'
            label={option.label}
            description={option.description}
            icon={option.icon}
            iconLayout={iconLayout}
            disabled={option.disabled}
            controlPosition={controlPosition}
            controlProps={{ value: option.value, checked: value === option.value }}
            cardSx={{ flex: 1 }}
          >
            {value === option.value ? option.content : null}
          </SelectionCard>
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioCardGroup
